
function Footer() {
  return (
    <footer style={footerStyle}>
      <div className="d-flex flex-column footer">
        <div className="olazsports-icon"> <img src="\Images\olazsports.png" alt="" /></div>
            <div>&copy; 2023 <span id="ola-footer">Olaz</span><span id="sports-footer">Sports</span> Intermediary.</div>
            <div>All Rights Reserved</div>
      </div>
    </footer>
  );
}

const footerStyle = {

  color: "#fff",
  backgroundColor: "rgb(20, 20, 20)",
  padding: "4px",
  margin: '0px !important',
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "200px",
  zIndex:"100",
  width: "100%",
  fontSize: "20px",
  fontFamily: " 'Palanquin Dark', sans-serif",
  fontWeight: "700"
};

export default Footer;
